document.addEventListener("DOMContentLoaded", function () {
  const listItems = document.querySelectorAll(".multicolumn-list__item");
  const main = document.querySelector("main"); // Target the <main> element
  let lastFocusedElement = null; // Store last focused element before opening modal

  function trapFocus(modal) {
    const focusableElements = modal.querySelectorAll('button, a, input, textarea, select');
    if (focusableElements.length === 0) return;

    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    modal.addEventListener("keydown", function (event) {
      if (event.key === "Tab") {
        if (event.shiftKey) {
          // Shift+Tab: Move focus to last element if at first
          if (document.activeElement === firstElement) {
            event.preventDefault();
            lastElement.focus();
          }
        } else {
          // Tab: Move focus to first element if at last
          if (document.activeElement === lastElement) {
            event.preventDefault();
            firstElement.focus();
          }
        }
      }

      // Close modal on Escape key
      if (event.key === "Escape") {
        closeModal(modal);
      }
    });
  }

  function closeModal(modal) {
    modal.classList.remove("multicolumn-card-modal--show");
    main.classList.remove("modal-overlay");
    modal.setAttribute("aria-hidden", "true"); // Hide modal from screen readers

    // Remove the class that disables scrolling on the body
    document.body.classList.remove("modal-open");

    // Restore focus to the last clicked element
    if (lastFocusedElement) {
      lastFocusedElement.focus();
    }
  }

  listItems.forEach((item) => {
    item.addEventListener("click", () => {
      // ►►► NEW CODE ◄◄◄
      // Scroll so .multicolumn is 20px from the top of the viewport
      const multiCol = document.querySelector(".multicolumn");
      if (multiCol) {
        const rect = multiCol.getBoundingClientRect();
        const scrollTarget = rect.top + window.scrollY - 20;
        window.scrollTo(0, scrollTarget);
      }
      // (End of new code)

      lastFocusedElement = document.activeElement; // Store the last focused element
      const index = item.getAttribute("data-index");
      const modal = document.querySelector(`.multicolumn-card-modal[data-index="${index}"]`);

      if (modal) {
        // Scroll a little if you want (as in your original code)
        window.scrollBy(0, 10);

        modal.classList.add("multicolumn-card-modal--show");
        main.classList.add("modal-overlay");
        modal.setAttribute("aria-hidden", "false"); // Announce modal to screen readers

        // Add the class that disables scrolling on the body
        document.body.classList.add("modal-open");

        // Move focus to the modal
        modal.setAttribute("tabindex", "-1");
        modal.focus();
        trapFocus(modal);
      }
    });
  });

  const modals = document.querySelectorAll(".multicolumn-card-modal");

  modals.forEach((modal) => {
    const closeButton = modal.querySelector(".multicolumn-card-modal__close-button");

    if (closeButton) {
      closeButton.addEventListener("click", (event) => {
        event.stopPropagation();
        closeModal(modal);
      });
    }
  });

  // Close modal when clicking outside it on the main overlay
  main.addEventListener("click", (event) => {
    if (event.target === main) {
      document.querySelectorAll(".multicolumn-card-modal--show").forEach(closeModal);
    }
  });
});
